import { render, staticRenderFns } from "./TaskHighlightTextCard.vue?vue&type=template&id=10fd749c&scoped=true&"
import script from "./TaskHighlightTextCard.vue?vue&type=script&lang=ts&"
export * from "./TaskHighlightTextCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskHighlightTextCard.vue?vue&type=style&index=0&id=10fd749c&prod&lang=css&"
import style1 from "./TaskHighlightTextCard.vue?vue&type=style&index=1&id=10fd749c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fd749c",
  null
  
)

export default component.exports